import { createDateTimeColumn } from '@app/components/date/create-date-time-column';
import { createCustomIdColumn } from '@app/modules/audit/components/create-custom-id-column';
import { auditSupport } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { Box } from '@mui/material';
import { MRT_ColumnDef, MRT_Row } from 'material-react-table';
import { useIntl } from 'react-intl';

export type LtxPreviewProps = {
  entries: auditSupport.LtxEntryDto[];
};

export function LtxPreview({ entries }: LtxPreviewProps) {
  const { $t } = useIntl();

  const columns: MRT_ColumnDef<auditSupport.LtxEntryDto>[] = [
    {
      accessorKey: 'index',
      header: $t({ id: 'common.columnIndex', defaultMessage: '#' }),
      size: 50,
      Cell: ({ row }: { row: MRT_Row<auditSupport.LtxEntryDto> }) => row.index + 1,
      enableSorting: false,
      enableColumnFilter: false,
    },
    createDateTimeColumn<auditSupport.LtxEntryDto>($t, {
      accessor: (row) => row.datetime,
      size: 200,
    }),
    {
      accessorKey: 'type',
      header: $t({ id: 'common.type', defaultMessage: 'Tipo' }),
      size: 150,
    },
    createCustomIdColumn<auditSupport.LtxEntryDto>($t, {
      accessor: (row) => row.customId,
      size: 200,
    }),
    {
      accessorKey: 'name',
      header: $t({ id: 'common.name', defaultMessage: 'Nombre' }),
      size: 250,
    },
  ];

  return (
    <Box mt={3}>
      <MrtTable
        columns={columns}
        data={entries}
        enableSorting
        enableColumnFilters
        enableGlobalFilter
        initialState={{
          density: 'compact',
          pagination: { pageSize: 50, pageIndex: 0 },
        }}
      />
    </Box>
  );
}
